import * as React from "react";
const SvgComponent = ({ strokeColor = "#90EE90", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="Layer_1"
    x={0}
    y={0}
    height="100%"
    width="100%"
    style={{
      enableBackground: "new 0 0 104.2 65.7",
    }}
    viewBox="0 0 104.2 65.7"
    {...props}
  >
     <style type="text/css">
      {
        `.st0{fill:none;stroke:${strokeColor};stroke-miterlimit:10;}
         .st1{fill:none;stroke:${strokeColor};stroke-width:1;stroke-miterlimit:9.9964;}
         .st2{fill:none;stroke:${strokeColor};stroke-miterlimit:9.9989;}
         .st3{fill:none;stroke:${strokeColor};stroke-width:0.77;stroke-miterlimit:10;}`
      }
    </style>
    <g id="Layer_2_00000065762999534967052760000011545545492183115412_">
      <g id="Layer_3_00000134222534219151621430000015566690309026192564_">
        <path
          className="st0"
          d="M52.8,57.1c1.1-5.7,1.3-12,3.5-15.5c4.2-7.3,13.3-6.2,11.6,8.1"
        />
        <line className="st0" x1={92.3} y1={40.8} x2={67.9} y2={49.7} />
        <path
          className="st0"
          d="M102.4,22.5c-2.1-3.7-1.3-3.6-4.1-4.2c-0.1,0-0.1,0-1.4-0.7"
        />
        <path className="st0" d="M64.6,36.3c-2.6-0.9-7.8,0.3-8.9,3.8" />
        <path className="st0" d="M64.5,36.3c4.8,2,4.8,10,3.6,13.3" />
        <line className="st0" x1={94.7} y1={37.2} x2={68.5} y2={46.6} />
        <line className="st0" x1={57.3} y1={40.2} x2={45.9} y2={41.3} />
        <path className="st0" d="M102.3,22.3c0.8,3.4,1.1,9.4-0.4,10" />
        <path className="st0" d="M98.7,22.7c3.7-0.4,5.1,2.5,3.9,7.1" />
        <path className="st0" d="M98.6,24.1c3.6,0.1,3.7,4.3,3.6,8.1" />
        <path className="st0" d="M92.2,38.1c0.7-2.1,1.3-15,6.5-14" />
        <path className="st0" d="M67.7,49.4c0.5,2.3,0,4.2-0.2,4.2" />
        <path className="st0" d="M43.7,58.6c3-0.8,5.9-1.6,9.6-1.9" />
        <path className="st0" d="M30.9,45.5c0.6,0.8,11.1,0.7,21.9-2.1" />
        <path className="st0" d="M1.7,35.3c-0.6,0-0.5,8,1.7,9" />
        <path className="st0" d="M3.1,44C2,45.8,4,47.8,5.9,47.9" />
        <line className="st0" x1={5.1} y1={47.7} x2={40.7} y2={58.6} />
        <path className="st0" d="M43.9,58.5c-0.5,0.1-2.6,0.3-3.4,0" />
        <path className="st0" d="M6.2,19.5c-2.1,5-2.1,11-1.7,13.3" />
        <path className="st0" d="M1.8,35.1c0,0.6,1.5,1,3.2,0.9" />
        <path className="st0" d="M4.6,32.5c0,0-1.6,2.1-2.9,2.8" />
        <path className="st0" d="M1.7,35.1c0.1,1.9,2.1,3.4,4,3.3" />
        <path className="st0" d="M57.1,40.5c0,0,4.1-0.1,4.4,0.9" />
        <path className="st0" d="M49.9,57.1c0.4,4.2,2.3,7.3,3.4,7.4" />
        <path className="st0" d="M60.1,64.9c-1,0-1.7,0.3-6.9-0.4" />
        <path className="st0" d="M98.9,26.4c-0.4-0.7-1.8-0.8-3.2-0.7" />
        <path className="st0" d="M91.5,38.2c0.3,2.8,1.9,4.2,2,4" />
        <path className="st0" d="M97.9,41.7c-0.1,0.1-2.9,0.6-4.5,0.5" />
        <path className="st0" d="M94.8,36.3c-2.5,1.8-3,1.6-2.9,2.1" />
        <g id="Layer_2_00000008850815465066213290000017902465927333571458_">
          <ellipse
            transform="matrix(3.939623e-02 -0.9992 0.9992 3.939623e-02 5.6303 112.2512)"
            className="st1"
            cx={61.2}
            cy={53.2}
            rx={11.8}
            ry={6.1}
          />
          <path
            className="st0"
            d="M56.7,53c-0.2,4.8,1.7,8.8,4.3,8.9c2.5,0.1,4.7-3.6,5-8.6c0.2-4.8-1.7-8.8-4.3-8.9 C59,44.3,56.8,48.2,56.7,53z"
          />
        </g>
        <g id="Layer_2_00000098189277519965804350000001933119724015553702_">
          <path
            className="st2"
            d="M94.5,34c0.2-4.2,2.4-7.6,4.4-7.5c2.1,0,3,3.4,2.9,7.7s-1.9,7.7-3.9,7.6C95.9,41.8,94.3,38.3,94.5,34z"
          />
          <path
            className="st0"
            d="M96.2,34c-0.2,3.4,0.7,5.9,1.9,5.9c1.2,0.1,2.3-2.5,2.5-5.7c0.2-3.4-0.7-5.9-1.9-5.9 C97.4,28.1,96.3,30.7,96.2,34z"
          />
        </g>
      </g>
    </g>
    <ellipse className="st3" cx={98.5} cy={34.1} rx={0.5} ry={1} />
    <ellipse className="st0" cx={61.2} cy={53.3} rx={0.8} ry={1.8} />
    <line className="st0" x1={61.2} y1={55.1} x2={61.2} y2={61.6} />
    <line className="st0" x1={61.3} y1={44.4} x2={61.2} y2={51.5} />
    <line className="st0" x1={60.5} y1={53.3} x2={56.7} y2={53.3} />
    <line className="st0" x1={62} y1={53.3} x2={66} y2={53.3} />
    <line className="st0" x1={65.3} y1={48} x2={61.9} y2={52.4} />
    <line className="st0" x1={60.5} y1={54.5} x2={57.3} y2={58} />
    <line className="st0" x1={57.7} y1={48} x2={60.5} y2={52.2} />
    <line className="st0" x1={62} y1={54.5} x2={64.9} y2={58.4} />
    <line className="st0" x1={98.5} y1={28.6} x2={98.6} y2={32.9} />
    <line className="st0" x1={98.5} y1={35.2} x2={98.5} y2={39.7} />
    <line className="st0" x1={99.1} y1={34.1} x2={100.4} y2={34.1} />
    <line className="st0" x1={97.7} y1={34.1} x2={96.2} y2={34} />
    <line className="st0" x1={98} y1={34.8} x2={96.6} y2={37} />
    <line className="st0" x1={100.3} y1={31.8} x2={99} y2={33.6} />
    <line className="st0" x1={96.8} y1={31.1} x2={98.1} y2={33.4} />
    <line className="st0" x1={99.1} y1={34.7} x2={100.2} y2={36.8} />
  </svg>
);
export default SvgComponent;
